import React, { useEffect } from "react";
import { SubTitle } from "@components/atoms/sub-title/sub-title";
import { Spacer16 } from "@components/atoms/spacer-16/spacer-16";
import { HintTitle } from "@components/atoms/hint-title/hint-title";
import transferButtonImg from "../../images/transfer-button.png";
import noStructureImgDragAndDrop from "../../images/no-structure-drag-and-drop.png";
import styles from "../TreeComponents.module.scss";
import { dropInitialListInEmptyOurNodeMachineStructure } from "./use-cases/drop-initial-list-in-empty-our-node-machine-structure";
import { BlueprintBannerFlexWrapper } from "@src/components/organisms/blueprint-banner-wrapper/blueprint-banner-flex-wrapper";
import { BigBlueprintBannerAutoMatch } from "@src/components/organisms/big-blueprint-banner-auto-match/big-blueprint-banner-auto-match";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { calcContentPaneHeightEmptyStructure } from "@src/cloud-connect/utils/calculate-content-pane-height-empty-structure";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasMultiplePermissions } from "@src/components/molecules/render-if-user-has-multiple-permissions/render-if-user-has-multiple-permissions";

const cssClassName = "tree-view-no-machine-structure-drag-and-drop";

export const TreeViewForNoOurNodeMachineStructureDragAndDrop = () => {
  const i18n = useI18N();

  const texts = {
    subTitle: i18n(
      "modules.treeViewNoOurNodeMachineStructureDragAndDrop.subTitle",
    ),
    hintTitle1: i18n(
      "modules.treeViewNoOurNodeMachineStructureDragAndDrop.hintTitle1",
    ),
    hintTitle2: i18n(
      "modules.treeViewNoOurNodeMachineStructureDragAndDrop.hintTitle2",
    ),
    noStructureImgDragAndDropAltText: i18n(
      "modules.treeViewNoOurNodeMachineStructureDragAndDrop.noStructureImgDragAndDropAltText",
    ),
    transferButtonImgAltText: i18n(
      "modules.treeViewNoOurNodeMachineStructureDragAndDrop.transferButtonImgAltText",
    ),
  };

  const handleNodesDrop = (e) => {
    e.preventDefault();
    dropInitialListInEmptyOurNodeMachineStructure();
  };

  /* handleNodesDrag
   *
   * !IMPRORTANT: This function is required to prevent the default behavior of the browser.
   * DO NOT REMOVE IT, otherwise the drop event will not be triggered.
   */
  const handleNodesDrag = (e) => {
    e.preventDefault();
  };

  /*
   *
   * !IMPRORTANT: This function is required to manage the state of the BlueprintStateInfoBanner component.
   * When the ndoe structure is emptied, the BlueprintStateInfoBanner component should be hidden and the isBlueprintApplied redux state should be reset on false.
   * DO NOT REMOVE IT.
   */
  /* useEffect(() => {
    dispatch(updateIsBlueprintApplied(false));
  }, []); */

  // this is a patch to avoid that when selecting all the nodes in the tree structure,
  // then filtering some nodes and activating the filter panel,
  // then deleting the whole selection the filter panel stays "active",
  // which would result in an empty filter panel when dragging again again from the initial structure.
  useEffect(() => {
    getMachineStructureNodeset().setShowFilterPanel(false);
  }, []);

  return (
    <div
      style={{
        height: calcContentPaneHeightEmptyStructure(),
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div
        className={styles[cssClassName]}
        onDrop={handleNodesDrop}
        onDragOver={handleNodesDrag}
      >
        <RenderIfUserHasMultiplePermissions
          permissions={["manage-blueprints", "view-blueprints"]}
        >
          <BlueprintBannerFlexWrapper>
            <BigBlueprintBannerAutoMatch />
          </BlueprintBannerFlexWrapper>
        </RenderIfUserHasMultiplePermissions>

        <div className={styles[`${cssClassName}__drop-zone`]}>
          <div style={{ textAlign: "center" }}>
            <div style={{ marginBottom: 7 }}>
              <SubTitle text={texts.subTitle} />
            </div>

            <img
              style={{ marginTop: -22 }}
              src={noStructureImgDragAndDrop}
              alt={texts.noStructureImgDragAndDropAltText}
            />
            <div
              style={{
                marginTop: -7,
              }}
            >
              <Spacer16>
                <HintTitle text={texts.hintTitle1} />
              </Spacer16>
              <div className={styles[`${cssClassName}__button-image-wrapper`]}>
                <img
                  src={transferButtonImg}
                  alt={texts.transferButtonImgAltText}
                />
                <HintTitle text={texts.hintTitle2} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
